import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { useQuery } from '@apollo/client';
import { Image } from '../../';
import { contentstackClient } from '../../../utils/contentstack-client';
import { GET_ARTICLES_BY_TAXONOMY } from '../../../enums/contentstack-graphql';
import { isValidArray } from '../../utilities/validations';

import styles from './index.module.scss';

// eslint-disable-next-line react/prop-types -- fix this
const FeaturedArticles = ({ data, dynamic, className, ...other }) => {
	const filters = isValidArray(dynamic?.filter_tags) ? dynamic?.filter_tags?.map((filter) => ({ taxonomies: { filter_by: { term_in: filter?.split(', ') } } })) : [];
	const { data: results } = useQuery(GET_ARTICLES_BY_TAXONOMY, { client: contentstackClient, variables: { filters }, skip: !isValidArray(dynamic?.filter_tags) });

	if (!isValidArray(results?.all_articles?.items)) return null;

	return (
		<div
			className={`${styles.featuredArticles} ${className || ''}`}
			{...other}
		>
			{results.all_articles.items.map((item, index) => (
				<div
					key={index}
					className={styles.featuredArticle}
				>
					<Link
						to={item.url}
						className={styles.featuredArticle_Link}
					>
						<span className={styles.featuredArticle_Badge}>Featured</span>

						{item.seo?.thumbnailConnect?.edges?.[0]?.node?.url && (
							<Image
								data={{ image: item.seo.thumbnailConnection.edges[0].node }}
								className={styles.featuredArticle_Image}
							/>
						)}

						<p className={styles.featuredArticle_Heading}>{item.top_content?.heading}</p>
					</Link>
				</div>
			))}
		</div>
	);
};

FeaturedArticles.propTypes = {
	dynamic: PropTypes.object,
	className: PropTypes.string,
};

export default FeaturedArticles;
